import React from 'react'
import cx from 'classnames'

import { SearchIcon } from '@wf-sl/common-icons'
import IconIndication from './icon-indication'
import propTypes from './props'

const defaultProps = {
    icon: <SearchIcon />
}

/**
 * Creates a simple element that shows a centered big icon with a text underneath. Uses <IconIndication />
 * The difference is that it shows a specific icon, when no other is provided, to indicate that data is missing:
 * https://confluence.tomtomgroup.com/display/TTB/Molecules#Molecules-NoData
 *
 * @example
 * <NoDataIndication key='example-3'>No result found.</NoDataIndication>
 *
 * @param {element=<SearchIcon/>}  icon                - An SVG-icon element (try to use a <SvgIcon />-derived icon)
 * @param {number=80}              iconSize            - the size of the icon
 * @param {string}                 className           - the css class to use for the wrapper styling
 * @param {string}                 classNameContent    - the css class to use for the content styling
 * @param {string}                 [text]              - the text under the icon;
 *                                                       if not set, children are used;
 *                                                       if set, passed children get ignored
 */
export default function NoDataIndication(props) {
    return (
        <IconIndication
            className={cx('t3sel-no-data-indicaton', props.className)}
            classNameContent={props.classNameContent}
            icon={props.icon}
        >
            {props.text || props.children}
        </IconIndication>
    )
}

NoDataIndication.propTypes = propTypes
NoDataIndication.defaultProps = defaultProps
